var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1768_38716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7947 19.0253H0.205333C0.40776 19.5113 0.749512 19.9265 1.18752 20.2186C1.62553 20.5107 2.1402 20.6666 2.66667 20.6667H21.3333C21.8598 20.6666 22.3745 20.5107 22.8125 20.2186C23.2505 19.9265 23.5922 19.5113 23.7947 19.0253ZM0 15.874H24V17.5813H0V15.874ZM7.66667 6.41933H24V8.12666H7.66667V6.41933ZM23.7947 4.97466C23.5922 4.48867 23.2505 4.07346 22.8125 3.78138C22.3745 3.48929 21.8598 3.33339 21.3333 3.33333H7.66667V4.97466H23.7947ZM7.66667 9.57066H24V11.278H7.66667V9.57066ZM0 12.722H24V14.4293H0V12.722Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 8.126H24V9.57067H7.66667V8.126ZM0 11.278V12.722H24V11.278H8H0ZM7.66667 4.97467V6.41934H24V6C24 5.63667 23.926 5.29067 23.7947 4.97467H7.66667ZM0 14.4293H24V15.874H0V14.4293ZM0 18C0 18.3633 0.074 18.7093 0.205333 19.0253H23.794C23.9297 18.7005 23.9997 18.352 24 18V17.5807H0V18Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 3C3.42899 3 2.242 3.35364 1.36683 3.98311C0.491665 4.61259 0 5.46634 0 6.35655L0 13H14V3H4.66667Z",
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99496 4.92801L2.75879 4.20135L2.52262 4.92801H1.75879L2.37687 5.37714L2.1407 6.10379L2.75879 5.65466L3.37687 6.10379L3.1407 5.37714L3.75879 4.92801H2.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99496 6.92801L2.75879 6.20135L2.52262 6.92801H1.75879L2.37687 7.37714L2.1407 8.10379L2.75879 7.65466L3.37687 8.10379L3.1407 7.37714L3.75879 6.92801H2.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99496 8.92801L2.75879 8.20135L2.52262 8.92801H1.75879L2.37687 9.37714L2.1407 10.1038L2.75879 9.65466L3.37687 10.1038L3.1407 9.37714L3.75879 8.92801H2.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99496 10.928L2.75879 10.2014L2.52262 10.928H1.75879L2.37687 11.3771L2.1407 12.1038L2.75879 11.6547L3.37687 12.1038L3.1407 11.3771L3.75879 10.928H2.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99496 4.92801L5.75879 4.20135L5.52262 4.92801H4.75879L5.37687 5.37714L5.1407 6.10379L5.75879 5.65466L6.37687 6.10379L6.1407 5.37714L6.75879 4.92801H5.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99496 6.92801L5.75879 6.20135L5.52262 6.92801H4.75879L5.37687 7.37714L5.1407 8.10379L5.75879 7.65466L6.37687 8.10379L6.1407 7.37714L6.75879 6.92801H5.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99496 8.92801L5.75879 8.20135L5.52262 8.92801H4.75879L5.37687 9.37714L5.1407 10.1038L5.75879 9.65466L6.37687 10.1038L6.1407 9.37714L6.75879 8.92801H5.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99496 10.928L5.75879 10.2014L5.52262 10.928H4.75879L5.37687 11.3771L5.1407 12.1038L5.75879 11.6547L6.37687 12.1038L6.1407 11.3771L6.75879 10.928H5.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99496 4.92801L8.75879 4.20135L8.52262 4.92801H7.75879L8.37687 5.37714L8.1407 6.10379L8.75879 5.65466L9.37687 6.10379L9.1407 5.37714L9.75879 4.92801H8.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99496 6.92801L8.75879 6.20135L8.52262 6.92801H7.75879L8.37687 7.37714L8.1407 8.10379L8.75879 7.65466L9.37687 8.10379L9.1407 7.37714L9.75879 6.92801H8.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99496 8.92801L8.75879 8.20135L8.52262 8.92801H7.75879L8.37687 9.37714L8.1407 10.1038L8.75879 9.65466L9.37687 10.1038L9.1407 9.37714L9.75879 8.92801H8.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99496 10.928L8.75879 10.2014L8.52262 10.928H7.75879L8.37687 11.3771L8.1407 12.1038L8.75879 11.6547L9.37687 12.1038L9.1407 11.3771L9.75879 10.928H8.99496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.995 4.92801L11.7588 4.20135L11.5226 4.92801H10.7588L11.3769 5.37714L11.1407 6.10379L11.7588 5.65466L12.3769 6.10379L12.1407 5.37714L12.7588 4.92801H11.995Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.995 6.92801L11.7588 6.20135L11.5226 6.92801H10.7588L11.3769 7.37714L11.1407 8.10379L11.7588 7.65466L12.3769 8.10379L12.1407 7.37714L12.7588 6.92801H11.995Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.995 8.92801L11.7588 8.20135L11.5226 8.92801H10.7588L11.3769 9.37714L11.1407 10.1038L11.7588 9.65466L12.3769 10.1038L12.1407 9.37714L12.7588 8.92801H11.995Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.995 10.928L11.7588 10.2014L11.5226 10.928H10.7588L11.3769 11.3771L11.1407 12.1038L11.7588 11.6547L12.3769 12.1038L12.1407 11.3771L12.7588 10.928H11.995Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1768_38716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.9b692b5a011e40b226953934711e573b.svg";
export { ForwardRef as ReactComponent };